import { exportToCSV, exportToPDF } from '../../../../utils/exportUtils';
import React, { useState, useRef } from 'react';
import AppCard from '../../../../components/ui/AppCard';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import apiClient from "../../../../services/api-client";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfirmPopup } from 'primereact/confirmpopup';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useMountEffect } from 'primereact/hooks';
import AddNewAd from "./AddNewAd"
import EditAd from "./EditAd"
import StorageHelper from '../../../../utils/storage-helper';

const AdsTable = () => {
  const [employees, setemployees] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [activeAds, setActiveAds] = useState(null)

  const dt = useRef(null);
  const toast = useRef(null);
  const [reloadData, setReloadData] = useState(false);






  const cols = [
    { field: 'title', header: 'Title' },
    { field: 'image', header: 'Image Url' },
    { field: 'description', header: 'Description' },
    { field: 'callToActionURL', header: 'Call To Action URL' },
    { field: 'actions', header: 'Actions' },
  ];

  useMountEffect(() => {
    fetchAdvertisements();
  }, [reloadData]);


  function renderActions(rowData) {
    return (
      <div className="actions-container flex items-center justify-center gap-2">
        <div className="tooltip" data-tip="Edit">
          <button
            className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
            onClick={() => {
              setReloadData(!reloadData);
              setActiveAds(rowData);
              setDialogVisible(!dialogVisible);
            }}
          >
            <i className="pi pi-pencil text-lg"></i>
          </button>
        </div>
      </div>
    );
  }

  const [dialogVisible, setDialogVisible] = useState(false);




  const fetchAdvertisements = async () => {
    try {
      await apiClient.get('advertisement/all', {
        headers: {
          Authorization: 'Bearer ' + (StorageHelper.get('token'))
        }
      }).then((response) => {
        // //console.log(response);
        if (response.data.status === "SUCCESS") {
          setemployees((response.data.responseBody));
        } else {
          //console.log(response.data.status);
        }
      });

    } catch (error) {
      //console.log(error)
    }
  };



    const globalFilterElement = (
    <div className="relative w-full max-w-xs">
        <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
        <input
            type="text"
            className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
        />
    </div>
  );

  const header = (
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
          {globalFilterElement}
          <div className="flex items-center gap-3 ml-auto">
              <button className="btn btn-primary rounded-full h-10 min-h-0 shadow-sm px-6" onClick={() => setDialogVisible(!dialogVisible)}>
                  <i className="pi pi-plus"></i> Create new
              </button>
              <div className="dropdown dropdown-end">
                  <div tabIndex={0} role="button" className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                      <i className="pi pi-file-export"></i> Export
                  </div>
                  <ul tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                                    <li><button type="button" onClick={() => exportToCSV(dt, 'Ads')}><i className="pi pi-file-excel text-success"></i> Download CSV</button></li>
                                    <li><button type="button" onClick={() => exportToPDF(dt, 'Ads', 'Ads Report')}><i className="pi pi-file-pdf text-error"></i> Download PDF</button></li>
                                </ul>
              </div>
          </div>
      </div>
  );

  const handleCreateUser = async () => {
    setDialogVisible(false)

    await toast.current.show({ severity: 'success', summary: 'Success', detail: 'User registered successfully' });

  }

  const imageBodyTemplate = (advertisement) => {
    return <img src={advertisement.image} alt={advertisement.image} className="w-2rem shadow-2 border-round" style={{ width: '80%' }} />;
  };

  return (


    <div className="w-full">
      <AppCard title="Manage Advertisements">
      <Toast ref={toast} />


      {activeAds === null ? (
        <Dialog header="Add new advertisement" visible={dialogVisible} maximizable style={{ width: '30vw' }} onHide={() => {
          setActiveAds(null)
          setDialogVisible(false)
        }}>
          <AddNewAd onCloseDialog={handleCreateUser} style={{ marginTop: "20px;" }} />
        </Dialog>
      ) : (
        <Dialog header="Edit user" visible={dialogVisible} maximizable style={{ width: '30vw' }} onHide={() => {
          setActiveAds(null)
          setDialogVisible(false)
        }}>
          <EditAd activeAds={activeAds} onCloseDialog={handleCreateUser} style={{ marginTop: "20px;" }} />
        </Dialog>
      )
      }




      <Tooltip target=".export-buttons>button" position="bottom" />
      <ConfirmPopup />

      

        <DataTable
          header={header}
          paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
          ref={dt}
          value={employees}
          tableStyle={{ minWidth: '50rem' }}
          globalFilter={globalFilter}
          emptyMessage="No advertisements found"
        >
          {cols.map((col, index) => {
            if (col.field === 'actions') {
              return (
                <Column
                  key={index}
                  body={renderActions}
                  style={{ textAlign: 'center' }}
                />
              );
            }
            if (col.field === 'image') {
              return (
                <Column key={index} body={imageBodyTemplate} header={col.header} />

              );
            }
            return (

              <Column key={index} field={col.field} header={col.header} />
            );
          })}
        </DataTable>
        </AppCard>
    </div>
  );
};

export default AdsTable;
